const Joi = require('joi')
const fields = require('./fields')

const idQuantitySchema = Joi.object({
    id: fields.objectIdField.required(),
    quantity: fields.integerAboveZeroField.required(),
})

module.exports = idQuantitySchema